import type { ParserError } from '../types'

type MessageExtractor<T> = (data: Readonly<{ message: string }>) => T | null

/**
 * Extracts the errors from the error message
 * @example {"code":"InvalidContent","message":"Error in commissioning file: []"}
 */
export const extractErrors: MessageExtractor<ParserError[] | null> = ({ message }) => {
    const errors = /^Error in commissioning file: (?<errors>.{2,})$/.exec(message)?.groups?.errors

    if (typeof errors !== 'string') {
        return null
    }

    try {
        return JSON.parse(errors) as ParserError[]
    } catch {
        return null
    }
}

/**
 * Extracts whether a service already exists
 * @example {"code":"InvalidContent","message":"Provided service id connectivitylayer already exists"}
 */
export const extractAlreadyExists: MessageExtractor<boolean> = ({ message }) => /^Provided service id .+ already exists$/.test(message)

/**
 * Extracts the creation error message
 * @example {"code":"InvalidContent","message":"Error on creating service connectivitylayer: ..."}
 */
export const extractCreationError: MessageExtractor<string | null> = ({ message }) => {
    const error = /^Error on creating service .+: (?<error>.+)$/.exec(message)?.groups?.error
    return typeof error === 'string' ? error : null
}
